import { render } from "./ViewsOrderSubmitProduct.vue?vue&type=template&id=e9943128"
import script from "./ViewsOrderSubmitProduct.vue?vue&type=script&lang=js"
export * from "./ViewsOrderSubmitProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__